module.exports = {
  setItem(itemName, itemValue) {
    return window.localStorage.setItem(itemName, itemValue);
  },
  itemExists(itemName) {
    return !!window.localStorage.getItem(itemName);
  },
};
